import { render, staticRenderFns } from "./SickLeave.vue?vue&type=template&id=a7dad73e"
import script from "./SickLeave.vue?vue&type=script&lang=js"
export * from "./SickLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports